module.exports = __webpack_public_path__ + "img/roma_linkem.f24a600a.png";